import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
    Button,
    Box,
    Typography,
    styled
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EggImage from "../static/img/egg.png"; // your egg image

// --- Styled Dialogs ---
const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        backgroundColor: '#FFE8BC',
        borderRadius: 16,
        padding: theme.spacing(2),
        minWidth: 300,
        minHeight: 380,
        border: 'black 2px solid',
        overflow: 'visible'
    }
}));

const HeaderButton = styled(Box)(() => ({
    backgroundColor: '#FFA800',
    color: 'black',
    padding: '8px 16px',
    borderRadius: 24,
    fontWeight: 600,
    border: 'black 2px solid',
    position: 'absolute',
    top: '-20px',
    left: '30%',
    maxWidth: 230
}));

const CopyButton = styled(Button)(() => ({
    backgroundColor: '#FAAE1C',
    color: 'black',
    borderRadius: 16,
    padding: '10px',
    width: '100%',
    '&:hover': {
        backgroundColor: '#e69e1a',
    },
    position: 'absolute',
    bottom: '20px',
    left: "15%",
    maxWidth: '70%'
}));

// --- Main Component ---
const EasterCodeDialog = ({ open, onClose, code = '' }) => {
    const [showEgg, setShowEgg] = useState(true);

    useEffect(() => {
        if (open) {
            setShowEgg(true);
        }
    }, [open]);

    const handleEggClick = () => {
        setShowEgg(false); // hide egg
    };

    const handleCopyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(code);
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
    };

    return (
        <>
            {/* Egg splash dialog */}
            <StyledDialog open={open && showEgg} onClose={handleEggClick} maxWidth="xs" fullWidth>
    <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography variant="h6" sx={{ color: "#FAAE1C", mb: 2 }}>
            Surprise Egg!
        </Typography>

        <img
            src={EggImage}
            alt="Egg"
            style={{
                width: 150,
                height: 200,
                animation: "zoomIn 1s ease",
                cursor: "pointer"
            }}
            onClick={handleEggClick}
        />

        <Typography variant="body2" sx={{ color: "black", mt: 2 }}>
            Please Click The egg to reveal your code 🎉
        </Typography>
    </Box>
</StyledDialog>


            {/* Code dialog */}
            <StyledDialog open={open && !showEgg} onClose={onClose} maxWidth="xs" fullWidth>
                <Box>
                    <HeaderButton>
                        Easter Egg Found!
                    </HeaderButton>
                    <IconButton
                        onClick={onClose}
                        sx={{
                            '&:hover': { backgroundColor: '#dbc69f' },
                            position: 'absolute',
                            top: '-20px',
                            right: '-10px',
                            border: '2px solid black',
                            color: 'black',
                            backgroundColor: '#FFE8BC'
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                <DialogContent sx={{ p: 0 }}>
                    <Typography
                        align="center"
                        variant="body2"
                        sx={{ mt: 10, color: 'black' }}
                    >
                        You've discovered an easter egg! Here's your code: <br />Use it to unlock the puzzles to win an exciting gift!
                    </Typography>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mt: 4
                    }}>
                        <Box sx={{
                            backgroundColor: '#fff',
                            border: '2px solid black',
                            borderRadius: 3,
                            padding: '10px 20px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '7px',
                            margin: '20px 0'
                        }}>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontFamily: 'monospace',
                                    letterSpacing: '0.2em',
                                    color: 'black'
                                }}
                            >
                                {code}
                            </Typography>
                        </Box>
                    </Box>

                    <CopyButton
                        onClick={handleCopyToClipboard}
                        variant="contained"
                        startIcon={<ContentCopyIcon />}
                    >
                        Copy to Clipboard
                    </CopyButton>
                </DialogContent>
            </StyledDialog>

            {/* CSS animation */}
            <style>
                {`
                @keyframes zoomIn {
                    from { transform: scale(0.5); opacity: 0; }
                    to { transform: scale(1); opacity: 1; }
                }
                `}
            </style>
        </>
    );
};

export default EasterCodeDialog;
